import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DiscountOfferFilterEntity } from '../../domain/entities/DiscountOfferFilterEntity'
export class DiscountOfferFilterModel extends DiscountOfferFilterEntity {
  categoryId?: number
  userId?: string
  fromStartDate?: string
  toStartDate?: string
  fromEndDate?: string
  toEndDate?: string
  branchId?:number

  constructor(dataDto: DiscountOfferFilterEntity) {
    super()
    mapEntityProperties<DiscountOfferFilterModel>(this, dataDto, {
      exclude: ['category', 'user', 'startDate', 'endDate' ,'branch'],
      map: {
        categoryId: dataDto.category?.id,
        branchId:dataDto.branch?.id,
        userId: dataDto.user?.id,
        fromStartDate: dataDto.startDate ? dataDto.startDate[0] : undefined,
        toStartDate: dataDto.startDate ? dataDto.startDate[1] : undefined,
        fromEndDate: dataDto.endDate ? dataDto.endDate[0] : undefined,
        toEndDate: dataDto.endDate ? dataDto.endDate[1] : undefined,
      }
    })
  }
}
